import { FaEnvelope, FaMapMarkedAlt, FaClock, FaPhoneAlt } from 'react-icons/fa';

const contacts = [  
    {
        id: 1, 
        icon: <FaPhoneAlt />,
        title: 'call us',
        content: [ '+123-456-7890', '+111-222-333'],
    },
    {
        id: 2,
        icon: <FaEnvelope />,
        title: 'email us',
        content: [ 'info@example.com', 'xyz@gmail.com'],
    },
    {
        id: 3,
        icon: <FaMapMarkedAlt />,
        title: 'office address',
        content: ['Botanica Company'],
    },
    {
        id: 4,
        icon: <FaClock />,
        title: 'open timing',
        content: ['Mon - Fri: 7 AM - 7 PM', 'Sat - Sun: 8 AM - 6 PM'],
    },
 
];

export default contacts;